import React from 'react';
import PropTypes from 'prop-types';

// This component now expects 'src' to be a React component.
const SvgImage = ({
  src: SvgComponent,
  fill = null,
  width = '24px',
  height = '24px',
  className = '',
  style = {},
  ...props
}) => {
  if (!SvgComponent) {
    return null;
  }

  return (
    <SvgComponent
      fill={fill}
      width={width}
      height={height}
      className={className}
      style={style}
      {...props}
    />
  );
};

SvgImage.propTypes = {
  src: PropTypes.elementType.isRequired, // Changed from string to elementType for React components
  fill: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object,
};

export default SvgImage;
